import { useEffect, useMemo, useState } from "react"
import { DialogTrigger } from "../../../../components/Dialog/Dialog"
import DeletePartDialog from "./DeletePartDialog"
import { getNla } from "../../services/NlaService"
import { NlaItem } from "./NlaItem"
import './Nla.css';
import Skeleton from "react-loading-skeleton"

export const Nla = ({ part }) => {

    const [nodes, setNodes] = useState([]);
    const [nodeBackup, setNodeBackup] = useState({});
    const [openedNodes, setOpenedNodes] = useState({});
    const [loading, setLoading] = useState(false);
    const [dropdownParams, setDropdownParams] = useState([]);

    const idxNodes = useMemo(()=> Object.fromEntries(nodes.map(n => [n.nodeId, n])) ,[nodes]);

    const showNode = (node) => node.parentIds.every(pId => openedNodes[pId] === true);
    const isNodeOpen = (node) => openedNodes[node.nodeId] === true;
    const toggleNode = (node) => setOpenedNodes(prev => ({ ...prev, [node.nodeId]: !prev[node.nodeId] }));
    const updateNode = (node) => {
        setNodes(prev => {
            let foundNodeIdx = prev.findIndex(n => n.nodeId === node.nodeId);
            if (foundNodeIdx > -1) {
                let copy = [...prev];
                copy[foundNodeIdx] = node;
                return copy;
            } else {
                return prev;
            }
        })
    }

    useEffect(() => {
        setLoading(true);
        getNla(part, true).then(response => {
            if (response.data.responseCode === 200) {
                setNodes(response.data.load.filter(p => !(p.part.id === part.id)));
                setOpenedNodes({ [response.data.load.find(p => p.part.id === part.id).nodeId]: true });
                setNodeBackup(response.data.load);
            }
            setLoading(false);
        }).catch(error => setLoading(false));
        setDropdownParams([{ "columnName": "partId", value: part.id }]);
    }, [part]);

    useEffect(() => {
    }, [nodes])

    const replaceInTree = (parts, idx, parentNodeLevel) => {

        setNodes(prev => {
            let endIdx = prev.findIndex((node, i) => (i > idx) && (node.level <= parentNodeLevel));
            return [...prev.slice(0, idx + 1),
            ...parts,
            ...prev.slice(endIdx > -1 ? endIdx : prev.length)
            ]
        })

    }

    const addSubLevel = ({ idx, level, parentNode, parentIds }) => {
        setNodes(prev => [
            ...prev.slice(0, idx + 1),
            { nodeId: crypto.randomUUID(), parentIds, level, parentNode, part: { id: null, positions: [], partNumber: "" } },
            ...prev.slice(idx + 1)
        ])
        setOpenedNodes(prev => ({ ...prev, [parentNode]: true }));
    }

    const discardNode = (nodeId) => {
        setNodes(prev => prev.filter(n => !((n.nodeId === nodeId)  || n.parentIds.includes(nodeId))));
    }

    useEffect(() => {
    }, [openedNodes])

    return (<div className=" section nla-component">
        <div className='section-header'>
            <h2>NLA</h2>
            { }
           {!loading && <button onClick={() => addSubLevel({ idx: -1, level: 0, parentNode: nodeBackup.find(p => p.part.id === part.id).nodeId, parentIds: [nodeBackup.find(p => p.part.id === part.id).nodeId] })} className='outlined icon small-size'>
                {/* <i onClick={() => addSubLevel(0, 0, nodeBackup.find(p => p.part.id === part.id))} className='icon-add-new'></i> */}
                <i className='icon-add-new'></i>
            </button>}


        </div>
        {(loading === false) && (nodes.length === 0) && <div className="placeholder">
            <i>The NLA hierarchy has not been configured for this part </i>
        </div>}
        {
            nodes.map((node, idx) => <NlaItem isNodeOpen={isNodeOpen} idxNodes={idxNodes}  dropdownParams={dropdownParams} updateNode={updateNode} showNode={showNode} toggleNode={toggleNode} discardNode={discardNode} treeBackup={nodeBackup} key={node.nodeId} node={node} idx={idx} tree={nodes} replaceInTree={replaceInTree} addSubLevel={addSubLevel} rootPart={part} />) // aquí el usa su componente de nla item
        }
        {loading && <>
            <Skeleton width="100%" height="2rem"></Skeleton>
            <Skeleton width="100%" height="2rem"></Skeleton>
       <Skeleton width="100%" height="2rem"></Skeleton> </>}
        <div className="spacer">

        </div>

    </div>)

}